import { courseIsArchived, courseIsFree, courseIsCustomPrice, courseIsLaunched, courseEnrollClosed, courseHasBuyAccess, courseHasSubAccess, courseHasBundleAccess, courseHasTrialAccess, currentUserHasCourseAccess, currentUserCanJoinCourse, currentUserHasBoughtCourse, currentUserHasJoinedCourse, subscriptionToken, subscriptionTokenTheoryOnly } from '~/utilities/courseState';
export default {
  computed: {
    subscriptionStore: function subscriptionStore() {
      return useSubscriptionStore();
    },
    isArchived: function isArchived() {
      return courseIsArchived(this.course);
    },
    isFree: function isFree() {
      return courseIsFree(this.course);
    },
    isCustomPrice: function isCustomPrice() {
      return courseIsCustomPrice(this.course);
    },
    isEnrollClosed: function isEnrollClosed() {
      return courseEnrollClosed(this.course);
    },
    canBuyAccess: function canBuyAccess() {
      return courseHasBuyAccess(this.course);
    },
    canBundleAccess: function canBundleAccess() {
      return courseHasBundleAccess(this.course);
    },
    canSubAccess: function canSubAccess() {
      return courseHasSubAccess(this.course);
    },
    canTrialAccess: function canTrialAccess() {
      return courseHasTrialAccess(this.course);
    },
    canJoin: function canJoin() {
      return currentUserCanJoinCourse(this.course);
    },
    isBought: function isBought() {
      return currentUserHasBoughtCourse(this.course);
    },
    isJoined: function isJoined() {
      return currentUserHasJoinedCourse(this.course);
    },
    hasAccess: function hasAccess() {
      return currentUserHasCourseAccess(this.course);
    },
    tokenBought: function tokenBought() {
      // We only have sub tokens, so this is always false
      return false;
    },
    now: function now() {
      return useTimeStore().now;
    },
    token: function token() {
      return subscriptionToken();
    },
    tokenTheoryOnly: function tokenTheoryOnly() {
      return subscriptionTokenTheoryOnly();
    },
    hasTrial: function hasTrial() {
      return this.subscriptionStore.trialVisible;
    },
    isLaunched: function isLaunched() {
      return courseIsLaunched(this.course);
    }
  }
};